module.exports = __webpack_public_path__ + "static/media/who-we-are-02@2x.e6ecfdc8.png";